import * as React from "react";
import { SVGProps } from "react";
export function GraduationCapIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20.071 18.108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m10.036.75 9.285 4.023-9.285 4.024L.75 4.773 10.036.75Z"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m4.963 6.609.01 4.377s1.532 2.029 5.062 2.029c3.53 0 5.071-2.029 5.071-2.029V6.61M2.458 13.941V5.526M2.458 17.358a1.708 1.708 0 1 0 0-3.417 1.708 1.708 0 0 0 0 3.417Z"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
